<template>
  <div style="min-height: 787px" class="container-xl climbing-new-editors-page">
  <div class="lds-ring" v-if="!isLoad">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
    <h2 class="inclusions-page-title">Inclusions & Exclusions</h2>
  <form v-if="isLoad">
    <div class="page-title page-title_price">
      <div class="climbing-head__rows" style="margin: 30px 0 15px">
        <div class="climbing-head__first-row">
          <div class="climbing-first-row-group">
          <div class="select__fields-group">
            <span class="select-label">Operator:</span>
            <ClassicSelect :items="formattedOperators" @select-item="(v) => this.operatorSelectedValue = v"/>
          </div>
          <button
              type="button"
              class="btn btn--green btn--sm-squared btn--popover btn--copy"
              data-popover="Copy inclusions from another operator"
              @click="copyPopupOperator = true"
          >
            <svg width="1em" height="1em" class="icon icon-copy ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
            </svg>
          </button>
          </div>
          <div class="climbing-first-row-group">
            <div class="select__fields-group">
              <span class="select-label">Route:</span>
              <ClassicSelect :items="routesData.map(r => ({...r, name: `${r.name} ${r.durationDays} days`}))" @select-item="(v) => this.routeSelectedValue = v"/>
            </div>
            <button
                type="button"
                class="btn btn--green btn--sm-squared btn--popover btn--copy"
                data-popover="Copy inclusions from another route"
                @click="copyPopupRoute = true"
            >
              <svg width="1em" height="1em" class="icon icon-copy ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
              </svg>
            </button>
          </div>
          <div class="climbing-first-row-group">
            <span class="select-label">Hotels & transfers included</span>
            <div style="margin-right: 10px">
              <ClassicSwitch v-model="includeHotelsAndTransfers"/>
            </div>
          </div>

          <div class="switcher-el  switcher-el_prices" style="margin-right: 0">
            <a href="#" :class="['switcher-el__item', {'active' : tab === 'CLASSIC'}]" @click="tab = 'CLASSIC'">
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <span class="switcher-el__text">Classic</span>
            </a>
            <a href="#" :class="['switcher-el__item', {'active' : tab === 'PREMIUM'}]" @click="tab = 'PREMIUM'">
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <svg width="1em" height="1em" class="icon icon-star">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
              </svg>
              <span class="switcher-el__text">Premium</span>
            </a>
          </div>
        </div>

      </div>
    </div>
    <div class="details-wrapper" v-if="details.details">
      <div class="languages-group">
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'EN'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'EN'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-gb ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">English</span>
        </label>
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'RU'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'RU'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-rus ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">Russian</span>
        </label>
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'DE'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'DE'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-deu ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">Deutch</span>
        </label>
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'ES'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'ES'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-deu ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">Spanish</span>
        </label>
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'FR'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'FR'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-deu ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">French</span>
        </label>
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'PT'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'PT'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-deu ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">Portuguese</span>
        </label>
        <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
               @click="activeDetail = 'NL'">
          <input type="radio" name="lanuage" :checked="activeDetail === 'NL'">
          <div class="np-detail-collapse__lang__icon">
            <svg width="1em" height="1em" class="icon icon-deu ">
              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
            </svg>
          </div>
          <span class="np-detail-collapse__lang__text">Dutch</span>
        </label>
      </div>
      <div class="text-edit-price-wrapper">
        <div class="text-edit-price">
          <div class="text-edit-price__item">
            <div class="text-edit-price__head">
                          <span class="text-edit-price__head-icon">
                            <svg width="1em" height="1em" class="icon icon-check ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                            </svg>
                          </span>
              Inclusions
            </div>
            <div class="form-control-wrap">
              <div class="text-heading">All transfers:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.allTransfers"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Hotel before and after the hike:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.hotelBeforeAndAfterHike"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Camping equipment:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.campingEquipment"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Meals on the hike:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.mealsOnHike"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Professional guides and porters:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.professionalGuides"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Oxygen tanks:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.oxygenTanks"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">GPS Trackers:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.gpsTrackers"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Medical check-ups, fully-loaded medical kits, and in-company doctor:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.medicalCheckups"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Fully-loaded medical kits:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.medicalKits"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Satellite phone:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.satellitePhone"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">All park fees and taxes:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.allParkFees"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Dedicated support team:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.dedicatedSupportTeam"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Innovative and user-friendly travel planning portal:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.innovateTravelPlanningPortal"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Safe room and storage room:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.safeStorageRoom"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Leave No Trace adventure:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.leaveNoTraceAdventure"
                          :config="editorConfig"></editor>
                </div>
              </div>
              <div class="text-heading">Impactful change for the local communities:</div>
              <div class="text-edit-price__text">
                <div class="js-ckeditor">
                  <editor @input="isEdit = true" :editor="editor"
                          v-model="details.details[activeDetail].inclusion.impactfulChangeForLocalCommunities"
                          :config="editorConfig"></editor>
                </div>
              </div>
            </div>

          </div>
          <div class="text-edit-price__item">
            <div class="text-edit-price__head">
                          <span class="text-edit-price__head-icon">
                            <svg width="1em" height="1em" class="icon icon-close ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                          </span>
              Exclusions
            </div>
            <div class="text-heading">International flights:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.internationalFlights"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Tips to the climbing crew:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.climbingCrewTips"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Visa fee:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.visaFee"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Personal gear rentals:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.personalGearRental"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Lunch and dinner in the hotel:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.lunchAndDinnerAtHotel"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Single supplement:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.singleSupplement"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Portable toilet:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.portableToilet"
                        :config="editorConfig"></editor>
              </div>
            </div>
            <div class="text-heading">Travel insurance:</div>
            <div class="text-edit-price__text">
              <div class="js-ckeditor">
                <editor @input="isEdit = true" :editor="editor"
                        v-model="details.details[activeDetail].exclusion.travelInsurance"
                        :config="editorConfig"></editor>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="table-save-btn" style="margin-right: 1.2rem">
        <button type="button" class="btn btn--green" @click="updateClimbingDetailsHandler"><span>Save</span>
        </button>
      </div>
    </div>
  </form>
    <div class="modal-wrapper" v-if="copyPopupRoute">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-md" style="width: 500px;">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
              </div>
              <span>Copy inclusions from another route</span>
            </div>
            <div class="edit-popup__close" @click="copyPopupRoute = false">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__form-2">
              <div class="form-control-group"><span class="form-control-label">Choose route</span>
                <div :class="['select-wrapper', { 'is-active' : copyPopupRouteOpen }]"
                     @click="copyPopupRouteOpen = !copyPopupRouteOpen">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{ copyPopupRouteFrom }}</span><span
                      class="select-trigger__icon">
										<svg width="1em" height="1em" class="icon icon-chevron ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
										</svg></span></div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                                          <div v-for="(route, index) in routesData.filter(r => r !== routeSelectedValue.name)" :key="index"
                                               :class="['select-option', { 'is-selected' : copyPopupRouteFrom === `${route.name} ${route.durationDays} days` }]"
                                               @click="copyPopupRouteFromId = route.id; copyPopupRouteFrom = `${route.name} ${route.durationDays} days`;"><span class="select-option__name">{{ `${route.name} ${route.durationDays} days` }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn--green edit-popup__submit-2"
                      @click="copyClimbingRoute();copyPopupRoute = false">
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
                <span>Copy</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="copyPopupOperator">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-md" style="width: 350px;">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
              </div>
              <span>Copy inclusions from another operator</span>
            </div>
            <div class="edit-popup__close" @click="copyPopupOperator = false">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__form-2">
              <div class="form-control-group"><span class="form-control-label">Choose operator</span>
                <div :class="['select-wrapper', { 'is-active' : copyPopupOperatorOpen }]"
                     @click="copyPopupOperatorOpen = !copyPopupOperatorOpen">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{ copyPopupOperatorFrom }}</span><span
                      class="select-trigger__icon">
										<svg width="1em" height="1em" class="icon icon-chevron ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
										</svg></span></div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                      <div v-for="(operator, index) in operators.filter(o => o !== operatorSelectedValue.companyName)" :key="index"
                           :class="['select-option', { 'is-selected' : copyPopupOperatorFrom === operator.companyName }]"
                           @click="copyPopupOperatorFromId = operator.id; copyPopupOperatorFrom = operator.companyName;"><span class="select-option__name">{{ operator.companyName }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn--green edit-popup__submit-2"
                      @click="copyClimbingOperator();copyPopupOperator = false">
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
                <span>Copy</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {TheMask} from 'vue-the-mask'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import ClassicSwitch from "@/components/UI/Switch/ClassicSwitch.vue";
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect.vue";
import {
  getClimbingRouteDetails,
  getPartners,
  getRoutesAll,
  createClimbingRouteDetails,
  updateClimbingRouteDetails,
  copyClimbingRouteById,
  copyClimbingOperatorById
} from "@/utilites/api";

export default {
  data() {
    return {
      copyPopupRoute: false,
      copyPopupRouteFrom: null,
      copyPopupRouteFromId: null,
      copyPopupRouteOpen: false,
      copyPopupOperator: false,
      copyPopupOperatorFrom: null,
      copyPopupOperatorFromId: null,
      copyPopupOperatorOpen: false,
      isLoad: false,
      routesData: null,
      routeSelectedValue: null,
      operators: null,
      operatorSelectedValue: null,
      includeHotelsAndTransfers: true,
      tab: 'CLASSIC',
      editorConfig: {
        placeholder: 'Description'
      },
      editor: ClassicEditor,
      activeDetail: 'EN',
      details: {
        details: {
          EN: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
          DE: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
          RU: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
          ES: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
          FR: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
          PT: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
          NL: {
            inclusion: {
              allTransfers: "",
              hotelBeforeAndAfterHike: "",
              campingEquipment: "",
              mealsOnHike: "",
              professionalGuides: "",
              oxygenTanks: "",
              gpsTrackers: "",
              medicalCheckups: "",
              medicalKits: "",
              satellitePhone: "",
              allParkFees: "",
              dedicatedSupportTeam: "",
              innovateTravelPlanningPortal: "",
              safeStorageRoom: "",
              leaveNoTraceAdventure: "",
              impactfulChangeForLocalCommunities: ""
            },
            exclusion: {
              internationalFlights: "",
              climbingCrewTips: "",
              visaFee: "",
              personalGearRental: "",
              lunchAndDinnerAtHotel: "",
              singleSupplement: "",
              portableToilet: "",
              travelInsurance: ""
            }
          },
        }
      },
    }
  },
  components: {ClassicSwitch, ClassicSelect, editor: CKEditor.component, TheMask},
  methods: {
    updateClimbingDetailsHandler() {
      if (this.details.id) {
        updateClimbingRouteDetails(this.details.id, {
          details: this.details.details,
        })
            .then(() => {
              this.$emit('confirmed')
              this.isEdit = false
            })
      } else {
        createClimbingRouteDetails({
          details: this.details.details,
          type: this.tab,
          routeId: this.routeSelectedValue.id,
          operatorId: this.operatorSelectedValue.id,
          includeHotelsAndTransfers: this.includeHotelsAndTransfers,
        })
            .then(() => {
              this.$emit('confirmed')
              this.isEdit = false
            })
      }
    },
    copyClimbingRoute() {
      copyClimbingRouteById({routeId: this.routeSelectedValue.id, fromRouteId: this.copyPopupRouteFromId})
            .then(() => {
              this.updateDetailsData();
              this.$emit('confirmed')
              this.isEdit = false
            })
    },
    copyClimbingOperator() {
      copyClimbingOperatorById({operatorId: this.operatorSelectedValue.id, fromOperatorId: this.copyPopupOperatorFromId})
          .then(() => {
            this.updateDetailsData();
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateDetailsData() {
      getClimbingRouteDetails(this.operatorSelectedValue.id, this.routeSelectedValue.id, this.tab, this.includeHotelsAndTransfers)
          .then(res => {
            this.details = {...res, details: {...this.details.details, ...res.details}}
          })
          .catch(() => {
            this.details = {
              details: {
                EN: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
                DE: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
                RU: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
                ES: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
                FR: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
                PT: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
                NL: {
                  inclusion: {
                    allTransfers: "",
                    hotelBeforeAndAfterHike: "",
                    campingEquipment: "",
                    mealsOnHike: "",
                    professionalGuides: "",
                    oxygenTanks: "",
                    gpsTrackers: "",
                    medicalCheckups: "",
                    medicalKits: "",
                    satellitePhone: "",
                    allParkFees: "",
                    dedicatedSupportTeam: "",
                    innovateTravelPlanningPortal: "",
                    safeStorageRoom: "",
                    leaveNoTraceAdventure: "",
                    impactfulChangeForLocalCommunities: ""
                  },
                  exclusion: {
                    internationalFlights: "",
                    climbingCrewTips: "",
                    visaFee: "",
                    personalGearRental: "",
                    lunchAndDinnerAtHotel: "",
                    singleSupplement: "",
                    portableToilet: "",
                    travelInsurance: ""
                  }
                },
              }
            }
          })
    }
  },
  computed: {
    formattedOperators() {
      return this.operators ? this.operators.map((o) => ({id: o.id, name: o.companyName})) : [];
    }
  },
  mounted() {
    document.title = 'Includes / Excludes';
    Promise.allSettled(
        [
          getPartners(),
          getRoutesAll(),
        ])
        .then(res => {
          this.isLoad = true
          this.operators = res[0].status === "fulfilled" ? res[0].value : this.operators
          this.operatorSelectedValue = res[0].status === "fulfilled" ? res[0].value[0] : this.operatorSelectedValue
          this.routesData = res[1].status === "fulfilled" ? res[1].value : this.routesData
          this.routeSelectedValue = res[1].status === "fulfilled" ? res[1].value[0] : this.routeSelectedValue
          return this.updateDetailsData();
    })
  },
  watch: {
    tab() {
      this.updateDetailsData();
    },
    operatorSelectedValue(newVal, oldVal) {
      if (oldVal) {
        if (newVal.id !== oldVal.id) {
          this.updateDetailsData();
        }
      } else {
        this.updateDetailsData();
      }
    },
    routeSelectedValue(newVal, oldVal) {
      if (oldVal) {
        if (newVal.id !== oldVal.id) {
          this.updateDetailsData();
        }
      } else {
        this.updateDetailsData();
      }
    },
    includeHotelsAndTransfers() {
      this.updateDetailsData();
    },
  }
}
</script>
<style lang="scss" scoped>
.select {
  &__fields-group {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  &-label {
    font-weight: 500;
    font-size: 1.2rem;
    color: #1b1b1b;
    line-height: 1.5em;
    margin-right: 10px;
  }
}
.climbing-head {
  &__table-title {
    margin-bottom: 15px;
  }

  &__rows {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  &__first-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
  }
  &__second-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;

  }

  &__first-row, &__second-row {
    display: flex;
    justify-content: space-between;
  }
}
.details-wrapper {
  background: #fff;
  padding-bottom: 21px;
  margin-top: 30px;
  -webkit-box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
.inclusions-page-title {
  margin-top: 35px;
  font-weight: 600;
}
.climbing-first-row-group {
  display: flex;
  align-items: center;
}
</style>

<style lang="css" scoped>
.climbing-new-editors-page >>> .ck-editor__editable_inline {
  min-height: 400px !important;
}
</style>